import { useContext } from "react";
import AuthContext from "../../components/auth-context";
import Button from "../../components/tailwind/button";
import AppLink from "../../components/router/app-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SGrid from "../../components/sgrid";
import ContactApi from "../../api/contact";

function Contacts() {
  const context = useContext(AuthContext);
  const { activeFileId } = context;
  const dataProvider = (page: number, pageSize: number) =>
    new ContactApi(context).get(page, pageSize);

  return (
    <>
      <Button
        className="btn bgc-white btn-light-secondary mx-0"
        dataToggle="tooltip"
      >
        <AppLink to="/registerContact">
          <FontAwesomeIcon icon="plus-circle" className="text-green" />
          <small className="ml-2">افزودن افراد مرنبط</small>
        </AppLink>
      </Button>
      <div className="card dcard overflow-x-scroll" style={{ padding: "5px" }}>
        <SGrid
          dataProvider={dataProvider}
          urlAddress={"/editContact"}
          columns={[
            ["سریال", "link", 0],
            ["نام", "farsi", 1],
            ["نام خانوادگی", "farsi", 2],
            ["عنوان", "farsi", 3],
            ["همراه", "farsi", 4],
            ["صاحب امضا", "boolean", 5],
          ]}
        />
      </div>
    </>
  );
}

export default Contacts;
